// Theme Specific Files

//codekit-prepend "popup.js"

(function ($) {

	"use strict";

	var $window,
		$body,
		$wpAdminBar,
		$siteHeader,
		$siteMain,
		$siteFooter;

	$(document).ready(jrDocumentReady);

	// Callback function for when the page is ready
	function jrDocumentReady() {

		$window = $(window);
		$body = $('body');
		$wpAdminBar = $('#wpadminbar');
		$siteHeader = $('#site-header');
		$siteMain = $('#site-main');
		$siteFooter = $('#site-footer');

		var scrolledFlag = false;

		if ($window.scrollTop() > 0) {
			$siteHeader.addClass('sticky');
		}

		// V Toggle
		$( '[data-v-toggle]' ).each( (e, f) => {

			var $this = $(f);
			new Toggle( $this );
			
		} );


		// Initialise
		var scrollTop = $window.scrollTop();
		var status = '';
		var lastDirection = '';
		var scrolling = false;

		$window.on( 'scroll', $.throttle( 250, () => {

			var newScrollTop = $(this).scrollTop();
			scrolling = true;

			// On scroll stop
			clearTimeout( $.data( this, 'scrollTimer' ) );
			$.data( this, 'scrollTimer', setTimeout( function() {
				
				$body.removeClass( 'scrolling-up' );
				$body.removeClass( 'scrolling-down' );
				scrolling = false;
				status = 'stopped';

			}, 500 ) );

			// At the top of the page
			if ( newScrollTop === 0 && status != 'top' ) {
				status = 'top';
				$body.addClass( 'scrolling-top' );
				$body.removeClass( 'scrolling-down scrolling-up' );
				scrolling = false;

			// Scrolling down
			} else if ( newScrollTop > scrollTop && status !== 'down' && scrolling ) {
				status = 'down';
				$body.addClass( 'scrolling-down' );
				$body.removeClass( 'scrolling-top scrolling-up' );
				lastDirection = 'down';
				$body.addClass( 'last-scrolled-down' );
				$body.removeClass( 'last-scrolled-up' );
				scrolling = true;


			// Scrolling up
			} else if ( newScrollTop < scrollTop && status !== 'up' && scrolling ) {
				status = 'up';
				$body.addClass( 'scrolling-up' );
				$body.removeClass( 'scrolling-down scrolling-top' );
				lastDirection = 'up';
				$body.removeClass( 'last-scrolled-down' );
				$body.addClass( 'last-scrolled-up' );
				scrolling = true;
				
			}

			scrollTop = newScrollTop;
		} ) );

		let mmenus = [];

		/*
		// MMenu TODO move this somewhere better
		*/
		$( '[data-v-mobile-menu' ).each( ( index, element ) => {

			let $menu = $( element );
			let data = $menu.data( 'v-mobile-menu' );

			// If using MMenu...
			if ( data.type === 'mmenu' ) {

				const mmenu = new Mmenu( '#' + $menu.prop( 'id' ), {
					// options
					"navbars": [
						{
						   "position": "bottom",
						   "content": [
							  "<a style='display:inline-block;padding:0.5rem;' class='fa fa-search v-open-search-box' href='#/'></a>",
						   ]
						}
					 ]
				}, {
					// configuration
					offCanvas: {
						page: {
							selector: data.body_wrap
						},
						clone: data.clone
					}
				});

				mmenus.push( mmenu );

			} else {

				// TODO

			}
			
		});

		$( '[href="#v-mobile-menu"]' ).on( 'click', e => {
			
			const panel = document.querySelector( "#mm-0" );
			mmenus[0].API.setSelected( panel );
			mmenus[0].API.openPanel( panel );


		} );

		// Open the services mobile
		$( '#open-services-mobile' ).on( 'click', e => {
			e.preventDefault();

			const panel = document.querySelector( "#mm-2" );
			mmenus[0].API.setSelected( panel );
			mmenus[0].API.openPanel( panel );
			mmenus[0].API.open();

		} );

		// Make text full width
		var fitties = fitty( '.fit-text' );
		fitties.forEach( fit => {
			setTimeout(() => {
				fit.fit();
			}, 1000);

		} );
		
		// Icon background
		$( '.icon-bg' ).each( ( index, el ) => {
			const $this = $(el);
			const $icon = $this.find( '.v-icon' ).clone().addClass( 'cloned' );
			$this.append( $icon );
		});

		// Disable help button
		$( '.item-ob-id-12144 > a' ).on( 'click', (e) => {
			e.preventDefault();
		});


		// Initialise V Toolbar object
		const vToolbar = new V_Toolbar();

		let hasLoaded = false;

		function onConversationsAPIReady() {

			// Only load once
			if ( hasLoaded ) {
				return;
			}

			hasLoaded = true;

			const status = window.HubSpotConversations.widget.status();
				
			if ( ! status.loaded ) {
				window.HubSpotConversations.widget.load({ widgetOpen: false });
			}

			// Open live chat
			$( '.open-live-chat' ).on( 'click', e => {
				e.preventDefault();

				if ( vToolbar.isOpen( 'chat-content' ) ) {
					vToolbar.close();
				} else {
					vToolbar.openPanel( 'chat-content' );
				}
				
			} );

			// Wait 5 seconds from page load then open
			setTimeout(() => {
				//vToolbar.open();
			}, 7500);

		}
		
		// Load chat api
		if (window.HubSpotConversations) {
			onConversationsAPIReady();
		} else {
			window.hsConversationsOnReady = [onConversationsAPIReady];
		}

		// Terms select
		$( '.v-shortcode-terms-select' ).on( 'change', e => {
			const $this = $( e.currentTarget );
			const url = $this.find( 'option:selected' ).val();
			window.location.href = url;
		} );

		// Open search dropdown
		$( 'body' ).on( 'click', '.v-open-search-box', e => {
			e.preventDefault();

			// Close MMenu
			mmenus[0].API.close();

			

			if ( $('body').hasClass( 'v-search-box-open' ) ) {
				$('body').removeClass( 'v-search-box-open' );
			} else {

				setTimeout(() => {
					$('body').addClass( 'v-search-box-open' );
					console.log('add class');
				}, 100);

				setTimeout(() => {
					$('.sub-search-dropdown input[type="search"]' ).focus();
				}, 210);
				
			}
			
		} );

		// Close on background click
		$( document ).on( 'click', e => {

			const $target = $( e.target );
			if ( ! $target.closest( '.sub-search-dropdown' ).length && ! $target.hasClass( 'v-open-search-box' ) ) {
				$('body').removeClass( 'v-search-box-open' );
			}

		} );

		// Open sidebar form
		$( '.v-open-side-popout' ).on( 'click', e => {
			
			const popout = $( '.v-side-popout-button > button' ).data( 'vPopupInstance' );
			
			if ( popout ) {
				popout.openFancybox( e );
			}

		} );
		
		// Mmenu open submenu
		$( 'body' ).on( 'click', '.id-v-menu-item-12210 > a', e => {
			e.preventDefault();

			const panel = document.querySelector( "#mm-1" );
			mmenus[0].API.setSelected( panel );
			mmenus[0].API.openPanel( panel );

		} );

		$( 'body' ).on( 'click', '.id-v-menu-item-12221 > a', e => {
			e.preventDefault();

			const panel = document.querySelector( "#mm-2" );
			mmenus[0].API.setSelected( panel );
			mmenus[0].API.openPanel( panel );

		} );

	}

	$(window).on( 'load', () => {

		// Lazyload images
		$( '.v-lazyload .lazy-img' ).each( (index, el) => {
			const $el = $(el);
			const $fullImg = $( $el.data( 'image' ) );
			$el.after( $fullImg );
			
		});

	});

	/**
	 * V Toolbar TODO as a module
	 */
	class V_Toolbar {

		constructor() {

			this.$container = $( '#v-contact-toolbar' );
			this.toolbarOpen = false;
			this.panelOpen = false;
			this.$body = $( 'body' );
			this.$tooltip = this.$container.find( '.tooltip' );

			this.initJS();

		}

		// Init the JS listeners
		initJS() {

			this.$container.on( 'click', '.open-menu', e => {
				e.preventDefault();

				this.toggleToolbar();
			} );

			this.$container.on( 'click', '[data-open-panel]', e => {
				e.preventDefault();
				const $this = $( e.currentTarget );
				const panel = $this.data( 'open-panel' );

				this.togglePanel( panel );
			});

			this.$container.on( 'click', '[data-close-toolbar]', e => {
				e.preventDefault();
				this.closeToolbar();
			});

			// Close on background click
			$( document ).on( 'click', e => {
				
				const $target = $( e.target );
				if ( ! $target.closest( '#v-contact-toolbar' ).length ) {
					this.close();
				}

			} );

			let hovered = false;

			// Open tooltip after 7 seconds if not seen already
			if ( ! localStorage.getItem( 'seenChatTooltip' ) ) {
				localStorage.setItem( 'seenChatTooltip', true );

				setTimeout(() => {

					if ( ! hovered ) {
						this.$tooltip.addClass( 'active' );
					}
				
				}, 7000 );

				setTimeout(() => {

					if ( ! hovered ) {
						this.$tooltip.removeClass( 'active' );
					}
					
				}, 14000 );

			}

			this.$tooltip.on('click', e => {
				$( 'body' ).addClass( 'v-toolbar-tooltip-dismissed' );
			});

			this.$container.on('mouseover', e => {
				hovered = true;
			});

		}

		// Toggle the toolbar buttons
		toggleToolbar() {

			if ( this.toolbarOpen ) {
				this.close();
			} else {
				this.open();
			}

		}

		// Open the toolbar
		openToolbar() {

			// Check if toolbar is already open
			if ( this.toolbarOpen || this.isTransitioning() ) {
				return new Promise( ( resolve, reject ) => {
					resolve( 'done' );
				} );
			}

			this.toolbarOpen = true;
			this.$body.addClass( 'v-toolbar-open' );
			this.$body.addClass( 'v-toolbar-opening' );

			return new Promise( ( resolve, reject ) => {
	
				setTimeout(() => {
					this.$body.removeClass( 'v-toolbar-opening' );
					resolve( 'done' );
				}, 500);

			} );

		}

		// Alias for openToolbar
		open() {
			return this.openToolbar();
		}

		// Close toolbar
		closeToolbar() {

			if ( this.isTransitioning() || ! this.$body.hasClass( 'v-toolbar-open' ) ) {
				return;
			}

			// If panel is open, close it
			this.closePanels().then( data => {

				this.toolbarOpen = false;
				this.$body.addClass( 'v-toolbar-closing' );
	
				setTimeout(() => {
					this.$body.removeClass( 'v-toolbar-closing' );
					this.$body.removeClass( 'v-toolbar-open' );
				}, 500);

			} );
			
		}

		// Alias for openToolbar
		close() {
			return this.closeToolbar();
		}

		// Toggle a panel
		togglePanel( panelID ) {

			if ( this.panelOpen === panelID ) {
				this.closePanels();
			} else {
				this.openPanel( panelID );
			}

		}

		// Open the panel
		openPanel( panelID ) {

			// Ignore if the panel is already open
			if ( this.panelOpen === panelID || this.isTransitioning() ) {
				return;
			}

			// If toolbar isn't open, open it
			this.openToolbar().then( data => {

				// If panels are not open...
				if( ! this.panelOpen ) {
					this.$body.addClass( 'v-toolbar-panel-open' );
				}

				this.panelOpen = panelID;
				this.$body.addClass( 'v-toolbar-panel-opening' );

				// Find panel and add active class
				const selector = `[data-panel-id="${panelID}"]`;
				const $panel = this.$container.find( selector );
				const buttonSelector = `[data-open-panel="${panelID}"]`;
				const $button = this.$container.find( buttonSelector );
				$panel.addClass( 'active' );
				$button.addClass( 'active' );

				// Remove other active classes
				this.$container.find( '[data-panel-id]' ).not( selector ).removeClass( 'active' );
				this.$container.find( '[data-open-panel]' ).not( buttonSelector ).removeClass( 'active' );

				setTimeout(() => {
					this.$body.removeClass( 'v-toolbar-panel-opening' );
				}, 500);
				
			} );
			
		}

		// Close the panel
		closePanels() {

			if ( this.panelOpen && ! this.isTransitioning() ) {

				this.panelOpen = false;
				this.$body.addClass( 'v-toolbar-panel-closing' );

				// Remove active buttons
				this.$container.find( '[data-open-panel]' ).removeClass( 'active' );
	
				return new Promise( ( resolve, reject ) => {
	
					setTimeout(() => {
						this.$body.removeClass( 'v-toolbar-panel-closing' );
						this.$body.removeClass( 'v-toolbar-panel-open' );
						this.$container.find( '[data-panel-id]' ).removeClass( 'active' );
						resolve( 'done' );
					}, 500);
	
				} );

			} else {

				return new Promise( ( resolve, reject ) => {
					resolve( 'done' );
				} );

			}

		}

		// Check if a panel is open. If no panel ID passed in, check if toolbar is open
		isOpen( panelID = null ) {

			if ( panelID ) {
				return this.panelOpen === panelID;
			}

			return this.toolbarOpen;

		}

		// Check if a panel is closed. If no panel ID passed in, check if toolbar is closed
		isClosed( panelID = null ) {

			if ( ! this.toolbarOpen || ! panelID ) {
				return this.toolbarOpen;
			}

			return this.panelOpen !== panelID;

		}

		// Is the toolbar currently transitioning
		isTransitioning() {

			if ( 
				this.$body.hasClass( 'v-toolbar-opening' ) ||
				this.$body.hasClass( 'v-toolbar-closing' ) ||
				this.$body.hasClass( 'v-toolbar-panel-opening' ) ||
				this.$body.hasClass( 'v-toolbar-panel-closing' )
			) {
				return true;
			}

			return false;

		}


	}


}(jQuery));


/**
 * Hubspot chat
 */
window.hsConversationsSettings = {
	inlineEmbedSelector: '#v-hs-chat',
	loadImmediately: false,
};




